import React from 'react';
import CloseablePage from '../CloseablePage';
import RequestPasswordResetWithData from 'components/RequestPasswordReset/RequestPasswordResetWithData';

function RequestPasswordResetPage() {
  return (
    <CloseablePage>
      <RequestPasswordResetWithData />
    </CloseablePage>
  );
}

export default RequestPasswordResetPage;



// WEBPACK FOOTER //
// ./src/containers/RequestPasswordResetPage/index.js